import { installKeyboardInput } from './keyboard';
import { installTouchInput } from './touch';

export function installGameInput(): () => void {
  const removeKeyboard = installKeyboardInput();
  const removeTouch = installTouchInput();
  return () => { removeKeyboard(); removeTouch(); };
}
